<template>
  <div class="overlay-full overlay-scheduled-video-call">
    <div class="overlay-content">
      <p class="title">Scheduled Video Call</p>
      <p id="scheduled-video-has-participant" style="display: none">The participant is already connected and waiting.</p>
      <div class="avatar">
        <img src="" id="scheduled-video-call-img" alt="">
      </div>
      <p id="scheduled-video-call-name"></p>
      <div>
        <a href="" class="btn btn-css3" id="scheduled-video-profile-button">Profile</a>
        <a href="" class="btn btn-primary" id="scheduled-video-call-button" target="_blank">Connect</a>
        <a href="#" class="btn btn-danger" id="scheduled-video-call-close">Close</a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "OverlayScheduledVideoCall"
}
</script>